import { usePermission } from '@fs/zion-permissions'

export default function useHasAdminPermissions() {
  const [hasPermission, status, error] = usePermission(
    'PublicDevPortalAPIGlobalAccountsAdminPermission',
    'PublicDevPortalAPIContext'
  )
  return { hasPermission, status, error }
}
